import React, { useState, useEffect } from 'react';
import { Container, Row, Col, InputGroup } from 'react-bootstrap';
import { axiosInstance } from '../../../../../../api/axios';
import { HttpSuccessCodes } from '../../../../../errorhandling/HttpErrorCodes';
import AddButton from '../../../UserFormNew/components/AddButton';
import FilterModal from '../../../../../components/common/filter-modal/FilterModal';
import { SearchSVG } from '../../../../../img/GlobalSVG';
import TextInput from '../../../../../../Components/GenericInputText/TextInput';
import APIEndpoints from '../../../../../api/APIEndpoints';
import Lists from '../Lists';

const BrokerPanel = ({
  label,
  deleteBrokerId,
  onSelectedBrokerHandler,
  createUserFormData,
  onSetAllBrokers,
  selectedBrokerData,
  editAffiliatedRecords,
}) => {
  const cacheBuster = (url) => `${url}?cb=${Date.now()}`;

  const [openBrokerModal, setOpenBrokerModal] = useState(false);
  const [brokerData, setBrokerData] = useState(createUserFormData.allBrokers);
  const [searchString, setSearchString] = useState('');
  const [searched, setSearched] = useState([]);
  const [searchedData, setSearchedData] = useState([]);
  let flag = false;

  const onChangeBrokerHandler = (e) => {
    setSearchString(e.target.value);
    const tempBroker2 = brokerData.filter(
      (broker) =>
        broker?.BrokerName?.toLowerCase().includes(
          e.target.value.toLowerCase(),
        ) ||
        broker?.Code?.toLowerCase().includes(e.target.value.toLowerCase()) ||
        broker?.TaxID?.toLowerCase().includes(e.target.value.toLowerCase()),
    );
    setSearchedData(tempBroker2);
    tempBroker2.map((location) => {
      if (location.isChecked === true) {
        return;
      } else {
        flag = true;
      }
    });
    if (!flag) {
      setSearched(tempBroker2);
    } else {
      setSearched([]);
    }
  };

  const handleAddBroker = () => {
    setOpenBrokerModal(true);
  };

  const applyFilterHandler = () => {
    const selectedBroker = brokerData.filter(
      (broker) => broker.isChecked == true,
    );
    onSelectedBrokerHandler(selectedBroker);
    setOpenBrokerModal(false);
    setSearchString('');
    setSearched([]);
  };

  const selectChangeHandler = (e) => {
    const { name, checked } = e.target;
    if (name === 'select-all-broker') {
      if (searchString === '') {
        const tempBroker = brokerData.map((broker) => {
          return { ...broker, isChecked: checked };
        });
        setBrokerData(tempBroker);
        onSetAllBrokers(tempBroker);
      } else {
        const tempBroker = brokerData.map((broker) =>
          broker?.BrokerName?.toLowerCase().includes(
            searchString.toLowerCase(),
          ) ||
          broker?.Code?.toLowerCase().includes(searchString.toLowerCase()) ||
          broker?.TaxID?.toLowerCase().includes(searchString.toLowerCase())
            ? { ...broker, isChecked: checked }
            : broker,
        );
        const data = tempBroker.filter((blob) => blob.isChecked === true);
        setSearched(data);
        setBrokerData(tempBroker);
        onSetAllBrokers(tempBroker);
      }
    } else {
      if (searchString === '') {
        const tempBroker = brokerData.map((broker) =>
          broker.Code === name ? { ...broker, isChecked: checked } : broker,
        );
        setBrokerData(tempBroker);
        onSetAllBrokers(tempBroker);
      } else {
        const tempBroker2 = brokerData.map((broker) =>
          broker?.BrokerName?.toLowerCase().includes(
            searchString.toLowerCase(),
          ) ||
          broker?.Code?.toLowerCase().includes(searchString.toLowerCase()) ||
          broker?.TaxID?.toLowerCase().includes(searchString.toLowerCase())
            ? broker.Code === name
              ? { ...broker, isChecked: checked }
              : broker
            : broker,
        );
        const tempBroker = tempBroker2.filter(
          (broker) =>
            broker?.BrokerName?.toLowerCase().includes(
              searchString.toLowerCase(),
            ) ||
            broker?.Code?.toLowerCase().includes(searchString.toLowerCase()) ||
            broker?.TaxID?.toLowerCase().includes(searchString.toLowerCase()),
        );
        //const tempBlob1 = tempBlob.map( blob => blob.BlkOfBusId === name ? { ...blob, isChecked: checked } : blob );
        tempBroker.map((broker) => {
          if (broker.isChecked === true) {
            return;
          } else {
            flag = true;
          }
        });
        if (!flag) {
          setSearched(tempBroker);
        } else {
          setSearched([]);
        }
        setBrokerData(tempBroker2);
        onSetAllBrokers(tempBroker2);
      }
    }
  };

  const getBrokerData = async () => {
    try {
      const BrokersListResponse = await axiosInstance.get(
        cacheBuster(APIEndpoints.getAllBrokers()),
      );
      if (
        BrokersListResponse.status === HttpSuccessCodes.HTTP_SUCCESS_CODE_200
      ) {
        if (BrokersListResponse?.data?.Response?.BrokerDemographic) {
          if (selectedBrokerData && selectedBrokerData.length > 0) {
            const brokerList =
              BrokersListResponse?.data?.Response?.BrokerDemographic;
            const tempObj = brokerList.map((item) =>
              selectedBrokerData.filter((selectedItem) =>
                Boolean(selectedItem.Code === item.Code),
              ).length
                ? { ...item, isChecked: true }
                : item,
            );
            setBrokerData(tempObj);
            onSetAllBrokers(tempObj);
          } else {
            setBrokerData(
              BrokersListResponse?.data?.Response?.BrokerDemographic,
            );
            onSetAllBrokers(
              BrokersListResponse?.data?.Response?.BrokerDemographic,
            );
          }
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (deleteBrokerId) {
      const tempBrokerData = brokerData.map((broker) =>
        broker.Code === deleteBrokerId
          ? { ...broker, isChecked: false }
          : broker,
      );
      const checkedBrokerData = tempBrokerData.filter(
        (broker) => broker.isChecked == true,
      );
      onSelectedBrokerHandler(checkedBrokerData);
      setBrokerData(tempBrokerData);
      onSetAllBrokers(tempBrokerData);
    } else {
      createUserFormData && createUserFormData.allBrokers.length > 0
        ? setBrokerData(createUserFormData.allBrokers)
        : getBrokerData();
    }
  }, [deleteBrokerId, selectedBrokerData]);

  console.log('brokerData', brokerData);

  return (
    <>
      {editAffiliatedRecords ? (
        <AddButton
          label={label}
          onClick={() => handleAddBroker()}
          className={'add-button-active'}
        />
      ) : (
        <AddButton label={label} className={'add-button-disable'} />
      )}
      <FilterModal
        showBackButton={false}
        isVisible={openBrokerModal}
        onHide={() => {
          setSearchString('');
          setOpenBrokerModal(false);
        }}
        applyFilterHandler={applyFilterHandler}
        showCancel={true}
        titleLabel="Broker(s)"
        showApply={true}
        showApplyLabel="Add Selected"
      >
        {brokerData && Object.keys(brokerData).length ? (
          <Container className="mt-3 mb-3">
            <Row>
              <Col sm={12}>
                <div>
                  <TextInput
                    parentClassName="mb-2"
                    label="Brokers"
                    append={
                      <InputGroup.Text>
                        <SearchSVG.SearchSVG className="primary-text-color" />
                      </InputGroup.Text>
                    }
                    inputProps={{
                      type: 'text',
                      placeholder: 'Search by name, tax ID or broker ID',
                      value: searchString,
                      onChange: onChangeBrokerHandler,
                      className: 'border-right-0',
                      autoFocus: false,
                      id: 'filter-broker-input',
                    }}
                  />
                </div>
              </Col>
            </Row>
            {searchString === '' ? (
              <>
                <Row>
                  <Col sm={12} className="mt-4 mb-2">
                    <div className=" select-all-row d-flex">
                      <input
                        type="checkbox"
                        id="select-all-broker"
                        name="select-all-broker"
                        className="p-0 mt-auto mb-auto"
                        onChange={(e) => {
                          selectChangeHandler(e);
                        }}
                        checked={
                          searchString === ''
                            ? createUserFormData &&
                              createUserFormData.allBrokers.length > 0
                              ? createUserFormData.allBrokers.filter(
                                  (broker) => broker.isChecked !== true,
                                ).length < 1
                              : brokerData.filter(
                                  (broker) => broker.isChecked !== true,
                                ).length < 1
                            : searched && searched.length
                            ? searched.filter((emp) => emp.isChecked !== true)
                                .length < 1
                            : brokerData.filter(
                                (broker) => broker.isChecked !== true,
                              ).length < 1
                        }
                      />
                      <label
                        className="my-auto select-all-checkbox"
                        htmlFor="select-all-blob"
                      >
                        Select All
                      </label>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col sm={12} className="mb-1">
                    <Lists
                      data={
                        createUserFormData &&
                        createUserFormData.allBrokers.length > 0
                          ? createUserFormData.allBrokers
                          : brokerData
                      }
                      selectChangeHandler={selectChangeHandler}
                      searchString={searchString}
                    />
                  </Col>
                </Row>
              </>
            ) : (
              <>
                {searchedData && Object.keys(searchedData).length ? (
                  <>
                    <Row>
                      <Col sm={12} className="mt-4 mb-2">
                        <div className=" select-all-row d-flex">
                          <input
                            type="checkbox"
                            id="select-all-broker"
                            name="select-all-broker"
                            className="p-0 mt-auto mb-auto"
                            onChange={(e) => {
                              selectChangeHandler(e);
                            }}
                            checked={
                              searchString === ''
                                ? createUserFormData &&
                                  createUserFormData.allBrokers.length > 0
                                  ? createUserFormData.allBrokers.filter(
                                      (broker) => broker.isChecked !== true,
                                    ).length < 1
                                  : brokerData.filter(
                                      (broker) => broker.isChecked !== true,
                                    ).length < 1
                                : searched && searched.length
                                ? searched.filter(
                                    (emp) => emp.isChecked !== true,
                                  ).length < 1
                                : brokerData.filter(
                                    (broker) => broker.isChecked !== true,
                                  ).length < 1
                            }
                          />
                          <label
                            className="my-auto select-all-checkbox"
                            htmlFor="select-all-blob"
                          >
                            Select All
                          </label>
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col sm={12} className="mb-1">
                        <Lists
                          data={
                            createUserFormData &&
                            createUserFormData.allBrokers.length > 0
                              ? createUserFormData.allBrokers
                              : brokerData
                          }
                          selectChangeHandler={selectChangeHandler}
                          searchString={searchString}
                        />
                      </Col>
                    </Row>
                  </>
                ) : (
                  <Container className="mt-3 mb-3">
                    <div>No Records Found</div>
                  </Container>
                )}
              </>
            )}
          </Container>
        ) : (
          <Container className="mt-3 mb-3">
            <div>No Records Found</div>
          </Container>
        )}
      </FilterModal>
    </>
  );
};

export default BrokerPanel;
